// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Luxon from "luxon";

function from(days, hours, milliseconds, minutes, months, seconds, weeks, years, param) {
  let tmp = {};
  if (years !== undefined) {
    tmp.years = Caml_option.valFromOption(years);
  }
  if (months !== undefined) {
    tmp.months = Caml_option.valFromOption(months);
  }
  if (weeks !== undefined) {
    tmp.weeks = Caml_option.valFromOption(weeks);
  }
  if (days !== undefined) {
    tmp.days = Caml_option.valFromOption(days);
  }
  if (hours !== undefined) {
    tmp.hours = Caml_option.valFromOption(hours);
  }
  if (minutes !== undefined) {
    tmp.minutes = Caml_option.valFromOption(minutes);
  }
  if (seconds !== undefined) {
    tmp.seconds = Caml_option.valFromOption(seconds);
  }
  if (milliseconds !== undefined) {
    tmp.milliseconds = Caml_option.valFromOption(milliseconds);
  }
  return Luxon.Duration.fromObject(tmp);
}

const Duration = {
  from: from
};

const DateTime = {};

export {
  Duration ,
  DateTime ,
}
/* luxon Not a pure module */
